export default __webpack_public_path__ + "static/media/cycloneofsteel6.c1801555.png";